import Destination from '@/components/Passenger/models/Destination';
import { AuthTenant, IApiAuthTenant } from './AuthTenant';

interface IApiOrganization {
    id: string;
    name: string;
    ptpDeductibleTypeIds: string;
    showSsn: boolean;
    requirePtpByDefault: boolean;
    savePtpAsDraftByDefault: boolean;
    ptpDeductiblePaymentBillableAsDefault: boolean;
    rideitEnabled: boolean;
    admins: string[];
    destinations: any[];
    authTenants: IApiAuthTenant[];
}

export class Organization {
    id: string;
    name: string;
    ptpDeductibleTypeIds: string;
    showSsn: boolean;
    requirePtpByDefault: boolean;
    savePtpAsDraftByDefault: boolean;
    ptpDeductiblePaymentBillableAsDefault: boolean;
    rideitEnabled: boolean;
    administratorIds: string[];
    destinations: Destination[];
    authTenants: AuthTenant[] = [];
    ptpNames: string[] = [];
    costCenterNames: string[] = [];

    public static fromApi(model: IApiOrganization): Organization {
        const organization = new Organization();
        organization.id = model.id;
        organization.name = model.name;
        organization.ptpDeductibleTypeIds = model.ptpDeductibleTypeIds;
        organization.showSsn = model.showSsn;
        organization.requirePtpByDefault = model.requirePtpByDefault;
        organization.savePtpAsDraftByDefault = model.savePtpAsDraftByDefault;
        organization.ptpDeductiblePaymentBillableAsDefault = model.ptpDeductiblePaymentBillableAsDefault;
        organization.rideitEnabled = model?.rideitEnabled ?? false;
        organization.administratorIds = model.admins;
        organization.destinations = model.destinations.map(d => new Destination(d));
        organization.destinations.sort((d1, d2) => (d1.alias || '').localeCompare((d2.alias || '')));
        organization.authTenants = model.authTenants ? model.authTenants.map(a => AuthTenant.fromApi(a)) : [];
        organization.ptpNames = [];
        organization.costCenterNames = [];
        return organization;
    }
}
